export const followMenu = () => {
    if (document.querySelector(".home")) {
        const header = document.querySelector('.header');

        const onScroll = () => {
            const scrollY = window.scrollY;
            const viewportHeight = window.innerHeight;

            if (scrollY > viewportHeight / 2) {
                header.classList.add('header--follow');
            } else {
                header.classList.remove('header--follow');
            }
        };

        window.addEventListener('scroll', onScroll);
    }

};